window.featured_categories_v2 = true;

$(document).ready(function () {
    $('[data-hero-slider]').slick('unslick')
    $('[data-hero-slider-nav]').slick('unslick')
    $('.product-nav').hide()
    $('.home-hero-slider').slick({
        dots: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000, 
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    arrows: false
                }
            },
        ]
    })
    $('.usp').slick({
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000, 
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    arrows: false
                }
            },
        ]
    })
  });

document.addEventListener('DOMContentLoaded', () => {
    console.log('adding listener to yotpo stars')
    if (document.querySelector('[data-products]')){
        setTimeout(() => {
            document.querySelectorAll('[data-product]').forEach(item => {
                
                let itemHref = item.querySelector('[data-url]').getAttribute('href')
                console.log('adding event listener', itemHref)
                item.querySelector('.yotpo-stars-only').addEventListener('click', (event)=> {
                    event.preventDefault()
                    console.log('item is clicked')
                    window.location.href = `${itemHref}#reviews-accordion`
                })
            })
        }, 150)

    }
})